import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { DishDetail } from "@/features/user/dish-detail"
import type { ItemDetail } from "@/features/user/types"

type Props = {
  item: ItemDetail
}

/**
 * `billId` is null and stays null: a pickup dish has no bill to join. The add
 * button is not blocked by that — `useDishOrder` knows it is writing to the
 * browser's cart.
 */
export default function UserPickupItem() {
  const { item } = usePage<Props>().props

  return (
    <UserLayout wide>
      <DishDetail item={item} billId={null} serviceContext="pickup" />
    </UserLayout>
  )
}
